import React, { createElement } from 'react';
import { FelaComponent } from '../../../Theme/utils/index';
import { WithDmId } from '../../../utils/BaseProps';

interface SpacerSizes {
  [breakpoint: string]: string | number;
}

interface DefaultStyleProps {
  theme: any;
  size: number;
  sizes: SpacerSizes;
}

type SpacerProps = WithDmId & {
  /**
   * String oder Number, mit dem die Größe des Abstands festgelegt wird.
   */
  size: number | string;
  /**
   * Object, mit dem unterschiedliche Abstände für bestimmte Breakpoints definiert werden können.
   */
  sizes?: SpacerSizes;
  /**
   * Optional kann das Styling des Spacers überschrieben werden.
   * Davon darf nur im Ausnahmefall Gebrauch gemacht werden!
   */
  style?: object;
  [otherProp: string]: any;
};

const defaultStyle = ({ theme, size, sizes = {} }: DefaultStyleProps) => ({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: size || 0,
  ...Object.keys(sizes).reduce((style: any, breakpoint) => {
    style[theme.breakpoints.horizontal[breakpoint].mediaQuery] = {
      flexBasis: sizes[breakpoint],
    };
    return style;
  }, {}),
});

export default function Spacer({
  dmId = 'dm-spacer',
  size,
  sizes,
  style = {},
  ...otherProps
}: SpacerProps) {
  return (
    <FelaComponent style={[defaultStyle, style]} size={size} sizes={sizes}>
      {({ className }: { className: string }) =>
        createElement(
          'div',
          {
            'data-designsystem': true,
            'data-dmid': dmId,
            className,
            ...otherProps,
          },
          null,
        )
      }
    </FelaComponent>
  );
}
